import ContactInfo from "../components/ContactInfo";

export default function Contact() {
  return (
    <div className="bg-custom-light-orange">
      <ContactInfo />
    </div>
  );
}
